import { Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

import store from "@/store";
import { MiraTrendGrain } from "@/utils/MiraTrendView";

const name = "miraTrendGrain";

if (store.state[name]) {
  store.unregisterModule(name);
}

/**
 * The Monat / Quartal / Jahr choice of the Mira timelines, shared by every Verlauf and comparison card
 * on every Mira screen, so clicking another tile or moving from Trocknung to Geräte never changes the
 * grain under the user (Hans, Track #2610047: "sometimes all diagrams are for the year, sometimes for
 * the quarters"). A card that does not offer the choice (a comparison has no Monat) draws its first
 * offered grain without overwriting it, see `offeredGrain`.
 *
 * Not persisted, like the comparison mode: it resets to Monat on a reload.
 */
@Module({ dynamic: true, namespaced: true, store, name })
export class MiraTrendGrainVuexModule extends VuexModule {
  grain: MiraTrendGrain = "month";

  @Mutation
  setGrain(grain: MiraTrendGrain) {
    this.grain = grain;
  }
}

export const MiraTrendGrainModule = getModule(MiraTrendGrainVuexModule);
